import { useContext, createContext } from 'react';
import { jsx } from 'react/jsx-runtime';

const SpeechSynthesisConfigContext = /*#__PURE__*/createContext({
  enabled: true,
  gender: "female",
  karaoke: true,
  languages: ["Danish"],
  latexPrinter: "mathematical",
  speed: 3
});
function useSpeechSynthesisConfig() {
  return useContext(SpeechSynthesisConfigContext);
}
function SpeechConfigProvider(props) {
  return /*#__PURE__*/jsx(SpeechSynthesisConfigContext.Provider, {
    value: props.config,
    children: props.children
  });
}

export { SpeechConfigProvider, useSpeechSynthesisConfig };
//# sourceMappingURL=context.config.js.map
